const rules = {
  user: {
    static: ["tickets:view", "contacts:view", "chat:use"],
  },

  motoqueiro: {
    static: ["tickets:view", "contacts:view", "chat:use"],
  },

  admin: {
    static: [
      "dashboard:view",
      "drawer-admin-items:view",
      "tickets-manager:showall",
      "user-modal:editProfile",
      "user-modal:editQueues",
      "ticket-options:deleteTicket",
      "contacts-page:deleteContact",
      "contacts-page:deleteAllContacts",
      "connections-page:actionButtons",
      "connections-page:addConnection",
      "connections-page:editOrDeleteConnection",
      "tickets-manager:closeAll",
    ],
  },

  gerente: {
    static: [
      "dashboard:view",
      "drawer-admin-items:view",
      "tickets-manager:showall",
      "user-modal:editProfile",
      "user-modal:editQueues",
      "ticket-options:deleteTicket",
      "contacts-page:deleteContact",
      "contacts-page:deleteAllContacts",
      "connections-page:actionButtons",
      "connections-page:addConnection",
      "connections-page:editOrDeleteConnection",
      "tickets-manager:closeAll",
    ],
  },

  super: {
    static: [
      "dashboard:view",
      "drawer-admin-items:view",
      "tickets-manager:showall",
      "user-modal:editProfile",
      "user-modal:editQueues",
      "ticket-options:deleteTicket",
      "contacts-page:deleteContact",
      "contacts-page:deleteAllContacts",
      "connections-page:actionButtons",
      "connections-page:addConnection",
      "connections-page:editOrDeleteConnection",
      "tickets-manager:closeAll",
      "all-connections:view",
      "companies:manage",
      "announcements:manage",
      "cross-company:access",
    ],
  },
};

export const canUserDeleteTicket = (user) => {
  if (!user) return false;
  if (user.super === true) return true;
  if (user.profile === "admin" || user.profile === "gerente") {
    return user?.permissions?.["tickets.delete"] !== false;
  }
  return Boolean(user?.permissions?.["tickets.delete"]);
};

export const canUserDeleteMessage = (user) => {
  if (!user) return false;
  if (user.super === true) return true;
  if (user.profile === "admin" || user.profile === "gerente") {
    return user?.permissions?.["tickets.deleteMessage"] !== false;
  }
  return Boolean(user?.permissions?.["tickets.deleteMessage"]);
};

export const canUserUseRotaVendas360 = (user) => {
  if (!user) return false;
  if (user.profile === "admin" || user.profile === "gerente" || user.super === true) return true;
  return (
    user.allowRotaVendas360 === "enabled" ||
    user.allowRotaVendas360 === true
  );
};

export default rules;
